module.exports = __webpack_public_path__ + "media/images/spot_symbolic-0bb1ee666d9460cfe05e13e16d168d2d.jpg";